import React from "react";

const Header3 = ({ children, style }) => {
  return <h3 style={style}>{children}</h3>;
};

export { Header3 };
